module.exports = __webpack_public_path__ + "static/media/Ramelan-Berserker.1b776556.png";